export function validateFilesLimit(params: {
  files: File[];
  maxFiles: number;
  maxTotalSizeBytes: number;
  existingFilesCount?: number;
  existingTotalSizeBytes?: number;
}): string | null {
  const { files, maxFiles, maxTotalSizeBytes, existingFilesCount = 0, existingTotalSizeBytes = 0 } = params;
  if (files.length + existingFilesCount > maxFiles) {
    return `You can only upload up to ${maxFiles} files at a time.`;
  }

  const totalSize = files.reduce((acc, f) => acc + f.size, 0) + existingTotalSizeBytes;
  if (totalSize > maxTotalSizeBytes) {
    return `Total file size exceeds ${maxTotalSizeBytes / 1024 / 1024} MB.`;
  }

  return null;
}
